export const assessmentTags = [
    { "text": "Aptitude Test" },
    { "text": "Cognitive Ability Test" },
    { "text": "Personality Test" },
    { "text": "Emotional Intelligence Test" },
    { "text": "Skills Assessment" },
    { "text": "Situational Judgement Test" },
    { "text": "Behavioral Assessment" },
    { "text": "Intelligence Test" },
    { "text": "Talent Assessment" },
    { "text": "Job Fit Assessment" },
    { "text": "Pre-employment Assessment" },
    { "text": "Workplace Assessment" }
];
